// Sorted by highest relevancy first. Lowest relevancy is -25 for match in company name.
// If no relevancy is set, ensure it's lower than -25.
export const DEFAULT_SEARCH_RELEVANCY_SCORE = -30;

// In some instances, server side search results are returned with relevancy score 2147483647.
// These are converted to DELFAULT_RELEVANCY_SCORE
export const INVALID_SEARCH_RELEVANCY_SCORE = 2147483647;

/**
 * Returns a valid relevancy score for provided score.
 */
export function normalizeRelevancyScore(relevancyScore: number): number {
    if (relevancyScore === undefined) {
        return 0;
    }

    return isNaN(relevancyScore) || relevancyScore === INVALID_SEARCH_RELEVANCY_SCORE
        ? DEFAULT_SEARCH_RELEVANCY_SCORE
        : relevancyScore;
}
